import { schGeoListingsFilters, schGeoSearch } from '@aloft/toolkit-shared';

import { z } from 'zod';

import { schCompSearch } from './types.ts';

export const schRecommendCompsForm = z.object({
  search: schCompSearch,
  originalSearch: schCompSearch,
});

export const schNewForm = z.object({
  search: z.object({
    filters: schGeoListingsFilters,
    geoSearch: schGeoSearch.optional(),
  }),
});
